<template>
  <div>
  <div id="shop-detail" v-show="!loading">
      <section :class="{ 'fade-base': true, 'fade': pageFade }">
        <div>
          <div class="l-shop__head--body">
            <div class="display-flex">
              <div v-if="provider.image" class="c-shop-info__img">
                <img v-lazy="getImgSrc(provider.image[0])" alt="">
              </div>
              <div v-else class="c-shop-info__img">
                <img src="/assets/images/aeontown-noimg.png" alt="">
              </div>
              <div class="c-shop-info__info">
                <div
                  class="c-detail--category--name mb-5"
                  :style="{
                    backgroundColor: shopCategoryTypes.find(
                      (category) => category.id == provider.shopCategoryType
                    )?.color,
                  }"
                >
                  {{
                    shopCategoryTypes.find(
                      (category) => category.id == provider.shopCategoryType
                    )?.name
                  }}
                </div>
                <div class="group-info">
                  <span class="mb-5 display-flex font-bold">{{ provider.shopName }}<br/></span>
                  <span class="mb-10 display-flex" v-if="provider.floorGuideNo">フロアガイド番号：<span class="c-tag--number"> {{ truncatedShopName(provider.floorGuideNo, 3) }}<br/></span></span>
                  <span class="center-between-item">
                    <span v-if="provider.location" class="center-all-item">
                      <img src="/assets/images/icon/icon-location.svg" class="mr-5" alt=""> {{ provider.location }}
                    </span>
                    <favorite-icon
                      :isActive="isActive(provider.id)"
                      :toggleFavorite="() => toggleFavoriteShop(provider.id)"
                    />
                  </span>
                </div>
              </div>
            </div>
            <p class="about-shop" v-if="provider.about" v-html="autolink(provider.about)"></p>
            <div class="postDetail__info-group">
              <div class="postDetail__info" v-if="provider.businessHourText">
                <div class="postDetail-title">営業時間</div>
                <div class="postDetail-text font-bold" v-html="nl2br(provider.businessHourText)"></div>
              </div>
              <div class="postDetail__info" v-if="provider.tel">
                <div class="postDetail-title">電話番号</div>
                <div class="postDetail-text font-bold">{{ provider.tel }}</div>
              </div>
              <div class="postDetail__info" v-if="hasAnyExternalLink(provider)">
                <div class="postDetail-title">SNS</div>
                <div class="postDetail-text">
                  <div class="display-flex">
                    <a v-if="provider.twitterUrl && !provider.hideTwitterUrl" href="" @click.prevent="Common.messageHandlers('show_browser', { url: provider.twitterUrl })" class="c-sns-group__item"><img src="/assets/images/icon/icon-twitter-new.svg" alt="" width="40" height="40" /></a>
                    <a v-if="provider.facebookUrl && !provider.hideFacebookUrl" href="" @click.prevent="Common.messageHandlers('show_browser', { url: provider.facebookUrl })" class="c-sns-group__item"><img src="/assets/images/icon/icon-facebook.svg" alt="" width="40" height="40" /></a>
                    <a v-if="provider.instagramUrl && !provider.hideInstagramUrl" href="" @click.prevent="Common.messageHandlers('show_browser', { url: provider.instagramUrl })" class="c-sns-group__item"><img src="/assets/images/icon/icon-instagram.svg" alt="" width="40" height="40" /></a>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="provider.siteUrl && !provider.hideUrl" class="btn-to-site bg-purple center-all-item mt-32">
              <a href="" @click.prevent="Common.messageHandlers('show_browser', { url: provider.siteUrl })">公式サイトへ</a>
            </div>
            <div class="btn-to-site mt-10 mb-16 c-btn-floor-guide center-all-item" v-if="showFloorGuide">
              <router-link to="/store/floorguide" class="center-all-item">
                <img src="/assets/images/icon/icon-map-location.svg" class="mr-5" alt="" />
                フロアガイドで確認
              </router-link>
            </div>
            <div class="line-break mt-24 mb-48"></div>
            <div class="mb-24" v-if="isMobileOrderEnabled()">
              <router-link v-if="provider.pickupEnabled && provider.pickupDiscloseAt < now" :to="`/mobileorder/pickup/shop`" class="c-btn c-btn--ct-left c-btn--grey box-center mb-8">
                <img src="/assets/images/icon/icon-ionic-md-phone-portrait.svg" alt="" />
                <label class="c-btn-desc">モバイルオーダー対応店　一覧へ</label>
              </router-link>
              <router-link v-if="provider.deliveryEnabled && provider.deliveryDiscloseAt < now && provider.handlingFormatDeliveryLane && provider.handlingFormatDeliveryLane.enabled" :to="`/mobileorder/drivethru/shop`" class="c-btn c-btn--ct-left c-btn--grey box-center mb-8">
                <img src="/assets/images/icon/icon-car.svg" alt="" />
                <label class="c-btn-desc">ドライブスルー対応店　一覧へ</label>
              </router-link>
              <router-link v-if="provider.deliveryEnabled && provider.deliveryDiscloseAt < now && provider.handlingFormatDeliveryParking && provider.handlingFormatDeliveryParking.enabled" :to="`/mobileorder/parkandpickup/shop`" class="c-btn c-btn--ct-left c-btn--grey box-center mb-8">
                <img src="/assets/images/icon/icon-car.svg" alt="" />
                <label class="c-btn-desc">駐車場受け取り対応店　一覧へ</label>
              </router-link>
              <router-link v-if="provider.reservationEnabled && provider.reservationDiscloseAt < now" :to="`/mobileorder/shop/${provider.id}/reservation`" class="c-btn c-btn--ct-left c-btn--grey box-center">
                <img src="/assets/images/icon/icon-reservation.svg" alt="" />
                <label class="c-btn-desc">ご来店予約はこちら</label>
              </router-link>
            </div>
          </div>
        </div>
      </section>
      <!-- list -->
      <section>
        <!-- list new -->
        <div class="l-list-menu top-content">
          <div class="l-list-menu__tab">
            <!-- swiper_tab -->
            <div class="shop-detail-menu">
              <div class="shop-menu-list">
                <div class="menu-item is-active" id="tab-0" @click="changeTab(0)">ショップニュース</div>
                <div class="menu-item" id="tab-1" @click="changeTab(1)">イベント</div>
                <div class="menu-item" id="tab-2" @click="changeTab(2)">クーポン</div>
              </div>
            </div>
            <NewsList 
              v-show="newsList && newsList.length > 0 && currentTab == 0"
              :newsList="newsList"
              :shopTop="shopTop"
              queryIdKey="newsId"
              :fromListNews="false"
            />
            <EventList
              v-show="eventsList && eventsList.length > 0 && currentTab == 1"
              :events="eventsList"
              queryIdKey="eventId"
              :fromListEvent="false"
            />
            <CouponList 
              :providerId="providerId"
              v-show="providerId && currentTab == 2"
              :fromListCoupon="false"
              queryIdKey="couponId"
            />
            <div
              v-if="(eventsList.length == 0 && currentTab == 1)
              || (newsList.length == 0 && currentTab == 0)"
              class="mt-16"
            >
              情報がございません。
            </div>
          </div>
        </div>
      </section>
      <div class="screen-loader loader--style1" :class="{ fade: !loading }" title="0">
        <svg version="1.1" id="loader-1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="40px" height="40px" viewBox="0 0 40 40" enable-background="new 0 0 40 40" xml:space="preserve">
          <path opacity="0.2" fill="#000" d="M20.201,5.169c-8.254,0-14.946,6.692-14.946,14.946c0,8.255,6.692,14.946,14.946,14.946 s14.946-6.691,14.946-14.946C35.146,11.861,28.455,5.169,20.201,5.169z M20.201,31.749c-6.425,0-11.634-5.208-11.634-11.634 c0-6.425,5.209-11.634,11.634-11.634c6.425,0,11.633,5.209,11.633,11.634C31.834,26.541,26.626,31.749,20.201,31.749z"/>
          <path fill="#000" d="M26.013,10.047l1.654-2.866c-2.198-1.272-4.743-2.012-7.466-2.012h0v3.312h0 C22.32,8.481,24.301,9.057,26.013,10.047z"></path>
        </svg>
      </div>
  </div>
  <loader :loading="loading" />
</div>
</template>

<script>
import "core-js/stable";
import "regenerator-runtime/runtime";
import Vue from "vue";
import { Common } from "../common/common.js";
import { Tenant } from "../plugin/mixin.js";
import {
  getUser,
  getProvider,
  getListShopProviders,
  getLocalNewsListOfProvider,
  getLocalAllEvents,
  getServerAllEvents,
  isShowFloorGuide
} from "../store/firestore.js";
const $ = window.$;
import loader from "../components/parts/loader.vue";
import FavoriteIcon from "../components/FavoriteIcon.vue";
import EventList from "../components/EventList.vue";
import NewsList from "../components/NewsList.vue";
import CouponList from "../components/CouponList.vue";

export default Vue.extend({
  name: "ShopList",
  props: {
    providerId: String,
    toggleFavoriteShop: {
      type: Function,
      required: true,
    },
    isActive: {
      type: Function,
      required: true,
    },
  },
  components: {
    loader,
    FavoriteIcon,
    EventList,
    NewsList,
    CouponList,
  },
  mixins: [Tenant],
  data() {
    return {
      user: undefined,
      provider: {},
      newsList: [],
      loader: false,
      newsAll: [],
      eventsList: [],
      Common: Common,
      loading: false,
      showFloorGuide: false,
      shopCategoryTypes: [
        { id: 1, name: "スーパーマーケット・総合スーパー", color: "#bc399b" },
        { id: 2, name: "ファッション", color: "#FF8773" },
        { id: 3, name: "グッズ", color: "#FF9F4B" },
        { id: 4, name: "サービス", color: "#18c173" },
        { id: 5, name: "グルメ＆フード", color: "#F1BF41" },
        { id: 6, name: "アミューズメント", color: "#4b98e5" },
      ],
      currentTab: 0,
    }
  },
  watch: {
    providerId: {
      handler: async function (newVal) {
        if (!newVal) return
        this.loading = true;
        this.providerId = newVal;
        await this.getDataProvider()
        await this.getDataNewsList()
        await this.getDataEventsList()
        this.loading = false;
      },
      immediate: true
    }
  },
  async created() {
    this.providersAll = await getListShopProviders(this.$store.state.shopId);
    this.user = await getUser(this.$store.state.userId);
    const shopId = this.$store.state.shopId;
    this.showFloorGuide = await isShowFloorGuide(shopId);
  },
  updated() {
		this.$nextTick(function () {
			Common.setKeepRatio()
		})
	},
  mounted() {
    Common.analyticsLogEvent('access_shoptop', {
      tenantId: this.providerId,
      shopId: this.SHOP_ID,
    });

    Common.initDom();
  },
  methods: {
    async getDataProvider() {
      const result = await getProvider(this.providerId)
      if (!result) return
      this.provider = result
    },
    async getDataNewsList() {
      const result = await getLocalNewsListOfProvider(this.providerId)
      if (!result) return
      this.newsList = result;
    },
    async getDataEventsList() {
      const eventAllList = await getLocalAllEvents()
      this.eventsList = eventAllList.filter(item => {
        return item.provider.id == this.providerId;
      });

      setTimeout(async () => {
        const eventAllList = await getServerAllEvents()
        this.eventsList = eventAllList.filter(item => {
          return item.provider.id == this.providerId;
        });
      });
    },
    hasAnyExternalLink(provider) {
      return (provider.twitterUrl && !provider.hideTwitterUrl)
        || (provider.facebookUrl && !provider.hideFacebookUrl)
        || (provider.instagramUrl && !provider.hideInstagramUrl)
    },
    changeTab(index) {
      $(".menu-item").removeClass("is-active");
      $(".menu-item").eq(index).addClass("is-active");
      this.currentTab = index;
      if (index == 2) {
        Common.analyticsLogEvent('use_coupon', {
          tenantId: this.providerId,
          couponId: '',
          shopId: this.SHOP_ID,
        });
      }
    },
  }
})
</script>